import { useTranslation } from '../../../i18n/useTranslation';
import { getBuildingSitesAddresses } from '../../../components/shopping-cart/services/shopping-cart.service';
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';

import {
    Dialog,
    DialogContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    IconButton,
    Stack,
    Pagination,
} from '@mui/material';
import BuildingSitesListSkeleton from '../../building-sites-list/building-sites-list-skeleton';
import { IPaginatedList } from '../../../shared/models/paginated-list.interface';
import { IBuildingSiteAddressListView } from '../../../components/order/interfaces/building-site-address-list-view.interface';

interface Prop {
    isOpen: boolean;
    handleCloseDialog: Function;
    selectedBuildingSiteUuid: string;
}

const BuildingSitesDeliveryAddressSelector: React.FC<Prop> = ({
    isOpen,
    selectedBuildingSiteUuid,
    handleCloseDialog,
}) => {
    const { t } = useTranslation('translation');
    const [page, setPage] = useState<number>(1);
    const [count, setCount] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [bulidingSiteAddresses, setBulidingSiteAddresses] = useState<IBuildingSiteAddressListView[]>([]);

    const handleClose = (selectedBuyerContact: IBuildingSiteAddressListView | null) => {
        handleCloseDialog(selectedBuyerContact);
    };

    const getAndSetBuildingSitesAddresses = (page: number) => {
        setIsLoading(true);
        getBuildingSitesAddresses(selectedBuildingSiteUuid, page).then((response) => {
            if (response) {
                const dto: IPaginatedList<IBuildingSiteAddressListView> = response.data;
                setBulidingSiteAddresses(dto.items);
                setPage(dto.pageIndex + 1);
                setCount(dto.totalCount);
                setIsLoading(false);
            } else {
                setIsLoading(false);
            }
        });
    };

    const handleChangePage = (page: number) => {
        getAndSetBuildingSitesAddresses(page);
    };

    useEffect(() => {
        getAndSetBuildingSitesAddresses(page);
    }, []);

    return (
        <div>
            <Dialog open={isOpen} onClose={() => handleClose(null)} fullWidth maxWidth="md">
                <DialogContent sx={{ position: 'relative' }}>
                    <Typography variant="h6" gutterBottom>
                        {t('SELECT_DELIVERY_ADDRESSS')}
                    </Typography>
                    <IconButton
                        onClick={() => {
                            handleClose(null);
                        }}
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    {isLoading ? (
                        <BuildingSitesListSkeleton count={3} />
                    ) : (
                        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            sx={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1 }}
                                        >
                                            <strong>{t('STREET')}</strong>
                                        </TableCell>
                                        <TableCell
                                            sx={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1 }}
                                        >
                                            <strong>{t('CITY')}</strong>
                                        </TableCell>
                                        <TableCell
                                            sx={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1 }}
                                        >
                                            <strong>{t('POSTAL_CODE')}</strong>
                                        </TableCell>
                                        <TableCell
                                            sx={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1 }}
                                        >
                                            <strong>{t('COUNTRY')}</strong>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {bulidingSiteAddresses.map((item) => (
                                        <TableRow
                                            onClick={() => {
                                                handleClose(item);
                                            }}
                                            key={item.id}
                                            sx={{
                                                '&:hover': {
                                                    backgroundColor: '#f2f2f2',
                                                    cursor: 'pointer',
                                                },
                                            }}
                                        >
                                            <TableCell sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                {item.streetName}
                                            </TableCell>
                                            <TableCell sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                {item.city}
                                            </TableCell>
                                            <TableCell sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                {item.postalCode}
                                            </TableCell>
                                            <TableCell sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                {t(item.countryName)}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                    <Stack spacing={2} alignItems="center" sx={{ mt: 2 }}>
                        <Pagination
                            sx={{
                                '& .MuiPaginationItem-root': {
                                    color: 'black',
                                    borderColor: '#821818 !important',
                                },
                                '& .Mui-selected': {
                                    backgroundColor: '#821818 !important',
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: '#821818 !important',
                                    },
                                },
                            }}
                            count={count}
                            boundaryCount={1}
                            page={page}
                            onChange={(_, page) => {
                                handleChangePage(page);
                            }}
                        />
                    </Stack>
                </DialogContent>
            </Dialog>
        </div>
    );
};
export default BuildingSitesDeliveryAddressSelector;
